var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 8.72163V15.2719H3.50165V8.72163H0.702148L7.00102 0.708496L13.2999 8.72163H10.5004Z",
    fill: "#4CD62B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3007 9.44964C13.0978 9.44964 12.8969 9.35866 12.7583 9.18254L6.99975 1.863L1.24188 9.18254C0.996224 9.49476 0.556702 9.53916 0.257156 9.28588C-0.0423906 9.03043 -0.0864815 8.57264 0.157775 8.26186L6.45735 0.253822C6.724 -0.0846074 7.2748 -0.0846074 7.54145 0.253822L13.8417 8.26186C14.0867 8.57264 14.0419 9.03115 13.7423 9.28588C13.6129 9.39578 13.4568 9.44964 13.3007 9.44964Z",
    fill: "#4CD62B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50017 16C3.11314 16 2.80029 15.6747 2.80029 15.2722V8.72195C2.80029 8.31947 3.11314 7.99414 3.50017 7.99414C3.8872 7.99414 4.20004 8.31947 4.20004 8.72195V15.2722C4.20004 15.6747 3.8872 16 3.50017 16Z",
    fill: "#4CD62B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4989 15.9997H3.50017C3.11314 15.9997 2.80029 15.6743 2.80029 15.2719C2.80029 14.8694 3.11314 14.5441 3.50017 14.5441H10.4989C10.8859 14.5441 11.1988 14.8694 11.1988 15.2719C11.1988 15.6743 10.8859 15.9997 10.4989 15.9997Z",
    fill: "#4CD62B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4992 16C10.1122 16 9.79932 15.6747 9.79932 15.2722V8.72195C9.79932 8.31947 10.1122 7.99414 10.4992 7.99414C10.8862 7.99414 11.1991 8.31947 11.1991 8.72195V15.2722C11.1991 15.6747 10.8862 16 10.4992 16Z",
    fill: "#4CD62B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50056 9.44975H0.700363C0.313332 9.44975 0.000488281 9.12442 0.000488281 8.72195C0.000488281 8.31947 0.313332 7.99414 0.700363 7.99414H3.50056C3.88759 7.99414 4.20043 8.31947 4.20043 8.72195C4.20043 9.12442 3.88759 9.44975 3.50056 9.44975Z",
    fill: "#4CD62B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 9.44975H10.4992C10.1122 9.44975 9.79932 9.12442 9.79932 8.72195C9.79932 8.31947 10.1122 7.99414 10.4992 7.99414H13.3001C13.6871 7.99414 14 8.31947 14 8.72195C14 9.12442 13.6871 9.44975 13.3001 9.44975Z",
    fill: "#4CD62B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.324c5abb9de42da4a2229a095dd4bbf0.svg";
export { ForwardRef as ReactComponent };